// Generated from LSEG Workspace's Excel add-in, Refinitiv for Office 26.30.2
// (resources/app.asar): its calendarCodes, ValidCurrencies, allowedDateFormats,
// sources and additionalTenorTypes. Codes, format strings and the values LSEG sends only.
// Do not edit; regenerate with tools/gen_adfin_data.py.

export const ADFIN_DATA_VERSION = "26.30.2";

/** LSEG's calendar codes (463), as the keys of its `calendarCodes`. */
export const CALENDAR_CODES: ReadonlySet<string> = new Set([
  "ABW", "AFG", "ALB", "ALG", "ANG", "ARG", "ARM", "AUM", "AUP", "AUS", "AUT", "AZE",
  "BAH", "BAN", "BAR", "BAS", "BBD", "BDI", "BEL", "BEN", "BER", "BFA", "BLZ", "BMA",
  "BOL", "BOS", "BRA", "BRA_BVMF", "BRU", "BTN", "BUL", "BVI", "BWA", "CAD_FXCALL", "CAD_FXALL", "CAF",
  "CAN", "CAR", "CAR_FI", "CAY", "CBA", "CDF", "CHI", "CHN", "CHX", "CMR", "COL", "COM",
  "CPV", "CRC", "CRO", "CYP", "CZE", "DEN", "DJI", "DOM", "DUB", "ECD", "EGY", "EMU",
  "ENX", "ERI", "EST", "EUR_FXCALL", "EUR_FXALL", "ETH", "EUR", "FIJ", "FIN", "FKI", "FRA", "GAM",
  "GBP_FXCALL", "GBP_FXALL", "GEO", "GER", "GHA", "GIB", "GIN", "GNB", "GRE", "GUN", "GUT", "GUY",
  "HAI", "HKG", "HON", "HUN", "ICL", "IDS", "IMF", "IND", "IRA", "IRL", "IRQ", "ISR",
  "ITL", "IVC", "JAM", "JAP", "JER", "JOR", "KAM", "KAZ", "KEN", "KGZ", "KOR", "KWT",
  "LAO", "LAR", "LAT", "LBA", "LEB", "LES", "LIH", "LUX", "MAC", "MAD", "MAL", "MDA",
  "MDV", "MEX", "MKD", "MLI", "MLT", "MND", "MNE", "MNT", "MOR", "MOZ", "MRT", "MSI",
  "MUS", "MWI", "NAM", "NAT", "NGN", "NGR", "NIC", "NKR", "NOR", "NPL", "NTL", "NULL",
  "NZL", "OMN", "PAK", "PAN", "PAR", "PER", "PHI", "PNG", "POL", "POR", "PRI", "QAT",
  "ROU", "RSA", "RUS", "RWA", "SAU", "SDN", "SEN", "SHN", "SIN", "SLB", "SLE", "SLK",
  "SLO", "SLV", "SOM", "SPA", "SRB", "SRI", "SSP", "STP", "SUR", "SWE", "SWI", "SWZ",
  "SYC", "SYR", "THA", "TJK", "TKM", "TOG", "TON", "TTO", "TUN", "TUR", "TWN", "TYO_ISDA",
  "TZA", "UAE", "UGA", "UKG", "UKIEUIPE", "UKLME", "UKLME_PROMPT", "UKR", "URU", "USA", "USM", "USN_FI",
  "UZB", "VEN", "VNM", "VUT", "WEEKEND", "WSM", "YEM", "ZMB", "ZWE", "ABW_FI", "ADE_FI", "AFG_FI",
  "AIA_FI", "ALB_FI", "ALG_FI", "AMS_FI", "ANG_FI", "ARG_FI", "ARM_FI", "ATL_FI", "AUS_FI", "AUM_FI", "AUP_FI", "AUT_FI",
  "AZE_FI", "BAH_FI", "BAN_FI", "BAR_FI", "BAS_FI", "BBD_FI", "BDI_FI", "BEL_FI", "BEN_FI", "BER_FI", "BFA_FI", "BLZ_FI",
  "BMA_FI", "BOL_FI", "BOS_FI", "BRA_FI", "BRC_FI", "BRI_FI", "BRU_FI", "BST_FI", "BTN_FI", "BUL_FI", "BUN_FI", "BVI_FI",
  "BWA_FI", "CAC_FI", "CAF_FI", "CAN_FI", "CAY_FI", "CBA_FI", "CDF_FI", "CHA_FI", "CHI_FI", "CHN_FI", "CHR_FI", "CHU_FI",
  "CHX_FI", "CMR_FI", "COG_FI", "COL_FI", "COM_FI", "CPV_FI", "CRC_FI", "CRO_FI", "CYP_FI", "CZE_FI", "DEL_FI", "DEN_FI",
  "DJI_FI", "DOM_FI", "DUS_FI", "ECD_FI", "EGY_FI", "EMU_FI", "ENX_FI", "ERI_FI", "EST_FI", "ETH_FI", "EUR_FI", "FER_FI",
  "FIJ_FI", "FIN_FI", "FKI_FI", "FRA_FI", "FRG_FI", "GAB_FI", "GAM_FI", "GEN_FI", "GEO_FI", "GER_FI", "GHA_FI", "GIB_FI",
  "GIN_FI", "GNB_FI", "GRE_FI", "GUN_FI", "GUT_FI", "GUY_FI", "HAI_FI", "HAM_FI", "HEI_FI", "HKG_FI", "HKG_RFR", "HOB_FI",
  "HON_FI", "HOU_FI", "HUN_FI", "ICL_FI", "IDS_FI", "IND_FI", "INU_FI", "IRA_FI", "IRL_FI", "IRQ_FI", "ISR_FI", "ITL_FI",
  "IVC_FI", "JAM_FI", "JAP_FI", "JPS_FI", "JER_FI", "JOR_FI", "KAM_FI", "KAZ_FI", "KEN_FI", "KGZ_FI", "KOR_FI", "KWT_FI",
  "LAO_FI", "LAR_FI", "LAT_FI", "LBA_FI", "LEB_FI", "LES_FI", "LIH_FI", "LNY_FI", "LNYFRT_FI", "LOS_FI", "LTK_FI", "LUX_FI",
  "MAC_FI", "MAD_FI", "MAL_FI", "MAS_FI", "MDA_FI", "MIL_FI", "MIN_FI", "MKD_FI", "MLI_FI", "MNP_FI", "MRD_FI", "MRT_FI",
  "MUS_FI", "MDV_FI", "MEX_FI", "MLT_FI", "MNT_FI", "MND_FI", "MNE_FI", "MON_FI", "MOR_FI", "MOZ_FI", "MSI_FI", "MUN_FI",
  "MWI_FI", "NAM_FI", "NAP_FI", "NAT_FI", "NCA_FI", "NGR_FI", "NGN_FI", "NIC_FI", "NKR_FI", "NOR_FI", "NPL_FI", "NTL_FI",
  "NEU_FI", "NYC_FI", "NZL_FI", "OMN_FI", "PAI_FI", "PAK_FI", "PAN_FI", "PAR_FI", "PER_FI", "PHI_FI", "POL_FI", "POR_FI",
  "PNG_FI", "QAT_FI", "ROU_FI", "RSA_FI", "RUS_FI", "RWA_FI", "SAN_FI", "SAU_FI", "SDN_FI", "SEN_FI", "SIE_FI", "SIN_FI",
  "SHN_FI", "SLB_FI", "SLE_FI", "SLK_FI", "SLO_FI", "SLV_FI", "SOM_FI", "SPA_FI", "SRB_FI", "SRI_FI", "STH_FI", "STP_FI",
  "STU_FI", "SUR_FI", "SWE_FI", "SWI_FI", "SWZ_FI", "SYC_FI", "SYR_FI", "TEX_FI", "THA_FI", "TJK_FI", "TKM_FI", "TOG_FI",
  "TON_FI", "TTO_FI", "TUI_FI", "TUN_FI", "TUR_FI", "TWN_FI", "TZA_FI", "UAE_FI", "UGA_FI", "UKG_FI", "UKS_FI", "UKR_FI",
  "URU_FI", "USA_FI", "USD_FXCALL", "USD_FXALL", "USM_FI", "UST_FI", "UZB_FI", "VEI_FI", "VEN_FI", "VIR_FI", "VNM_FI", "VUT_FI",
  "WSM_FI", "WUP_FI", "YEM_FI", "ZMB_FI", "ZWE_FI", "USC_FI", "US_NMM_FI",
]);

/** LSEG's valid currencies (203), the keys of every length in its `ValidCurrencies`. */
export const VALID_CURRENCIES: ReadonlySet<string> = new Set([
  "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "ATS", "AUD", "AWG", "AZN", "BAM",
  "BBD", "BCH", "BDT", "BEF", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL", "BSD",
  "BTC", "BTN", "BWP", "BYN", "BYR", "BZD", "CAD", "CDF", "CHF", "CLF", "CLP", "CNH",
  "CNY", "COP", "COU", "CRC", "CSD", "CUP", "CVE", "CYP", "CZK", "DEM", "DJF", "DKK",
  "DOP", "DZD", "ECS", "EEK", "EGP", "ERN", "ESP", "ETB", "ETH", "EUR", "FIM", "FJD",
  "FKP", "FRF", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GRD", "GTQ", "GYD", "HKD",
  "HNL", "HRK", "HTG", "HUF", "IDR", "IEP", "ILS", "INR", "IOT", "IQD", "IRR", "ISK",
  "ITL", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD",
  "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LTC", "LTL", "LUF", "LVL", "LYD", "MAD",
  "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRO", "MRU", "MTL", "MUR", "MVR", "MWK",
  "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NLG", "NOK", "NPR", "NZD", "OMR",
  "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PTE", "PYG", "QAR", "ROL", "RON", "RSD",
  "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SIT", "SKK", "SLL",
  "SOS", "SRD", "STD", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMM", "TMT", "TND",
  "TOP", "TRL", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "UYI", "UYU", "UZS",
  "VEF", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XCD", "XOF", "XPD", "XPF",
  "XPT", "XRP", "YER", "ZAR", "ZMK", "ZMW", "ZWD", "ZWL", "ZWR", "DASH", "SHICNY",
]);

/** The dayjs formats a date text is tried against, in LSEG's order. */
export const ALLOWED_DATE_FORMATS: Readonly<Record<string, readonly string[]>> = {
  dateHyphenFormats: ["YYYY-MM-DD", "DD-MM-YYYY", "DD-MM-YY"],
  dateSlashFormats: ["YYYY/MM/DD", "MM/DD/YYYY", "MM/DD/YY"],
  dateDotFormats: ["YYYY.MM.DD", "DD.MM.YYYY", "DD.MM.YY"],
  dateMonthNameFormats: ["YYYY-MMM-DD", "YYYY-DD-MMM", "MMM-DD-YYYY", "MMM-DD-YY", "DD-MMM-YYYY", "DD-MMM-YY"],
};

/** LSEG's FX sources (170), the keys of its `sources`. */
export const FX_SOURCES: ReadonlySet<string> = new Set([
  "Composite", "D4", "D3", "EBS", "S", "X", "N", "COBA", "EBIL", "TRB", "TUBD", "D2",
  "BARL", "ICBH", "EU", "CKLU", "SAHK", "RABL", "ABSA", "TTKL", "TKFX", "WPAC", "ABBT", "ZKBZ",
  "CRDA", "TMBK", "AFIN", "AKMI", "SSAL", "ICAP", "BNL", "PCBA", "NCAT", "CRCZ", "BCHK", "LBWX",
  "STDB", "TFIB", "COIB", "UBTA", "HSBL", "BCUY", "OTPH", "IPYU", "NDEA", "FMD", "DDBK", "KOBA",
  "SGEP", "TRBK", "SEBK", "IFLN", "IIBM", "SANM", "BTMJ", "TRDT", "DNBO", "NMST", "NEDB", "TDS",
  "NBKX", "BSMD", "CBTA", "NXIP", "ABIA", "UBSZ", "CMBN", "RCFX", "EBAG", "RBSL", "BTKL", "OTPT",
  "BCIA", "RAIF", "FUIB", "ALFN", "BCPL", "ICMM", "TRTB", "KIBX", "RDBE", "AWBC", "KFHK", "NTCS",
  "KFTC", "ICBC", "BDOF", "FISW", "CICZ", "BSAB", "PBGR", "SEBN", "BOYQ", "AMBB", "CBEE", "ACLB",
  "LUSO", "ABLE", "YAPI", "MHCQ", "CIBC", "EQBK", "BOCA", "NBTK", "ABLT", "ABLR", "IPBM", "UGAB",
  "PPFB", "BAGR", "ALXE", "GOTL", "D", "CFXS", "D1", "A", "CFXM", "E", "GB", "DE",
  "W", "M", "HK", "SEA", "J", "IT", "NY", "KZ", "AT", "RU", "CH", "MT",
  "NRD", "SS", "SI", "ES", "GR", "SWX", "CFXB", "CFXE", "BNAR", "FTXE", "RZBM", "CIMD",
  "HAIT", "TMFX", "CFXO", "CFXD", "PT", "PL", "FR", "KRKN", "ICNA", "OTPS", "BBHA", "ASAN",
  "OFCB", "SBHU", "AKBA", "NBBL", "CLBW", "SMBZ", "MBCA", "STZL", "SBZA", "ACTI", "ICND", "HSHY",
  "COMPOSITE", "REFINITIV",
]);

/** The `sources` entries whose value is a code LSEG sends ("COMPOSITE" -> "Composite"); the others are descriptions. */
export const FX_SOURCE_VALUES: ReadonlyMap<string, string> = new Map([
  ["Composite", "Composite"],
  ["COMPOSITE", "Composite"],
  ["REFINITIV", "Refinitiv"],
]);

/** LSEG's `additionalTenorTypes`: the lower-case name a user types -> the value LSEG sends. */
export const ADDITIONAL_TENOR_TYPES: ReadonlyMap<string, string> = new Map([
  ["standard", "Standard"],
  ["odd", "Odd"],
  ["long", "Long"],
  ["beginningofmonth", "BeginningOfMonth"],
  ["endofmonth", "EndOfMonth"],
  ["beginningofquarter", "BeginningOfQuarter"],
  ["endofquarter", "EndOfQuarter"],
]);
